import { render, staticRenderFns } from "./downLoad.vue?vue&type=template&id=201642a0&scoped=true&"
import script from "./downLoad.vue?vue&type=script&lang=js&"
export * from "./downLoad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201642a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('201642a0')) {
      api.createRecord('201642a0', component.options)
    } else {
      api.reload('201642a0', component.options)
    }
    module.hot.accept("./downLoad.vue?vue&type=template&id=201642a0&scoped=true&", function () {
      api.rerender('201642a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DesignEditor/component/common/downLoad.vue"
export default component.exports